import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AccountCard from '../../../../../cards/components/AccountCard';
import NativeActivityIndicator from '../../../../../../components/global/NativeActivityIndicator';
import CardElementPhotoPpiWarningModal from '../../../../../cards/components/CardElementPhoto/CardElementPhotoPpiWarningModal';
import useOpenModal from '../../../../../../hooks/useOpenModal';
import { CARD_ELEMENT_PHOTO_PPI_WARNING_MODAL } from '../../../../../cards/components/CardElementPhoto/CardElementPhotoPpiWarningModal/CardElementPhotoPpiWarningModal';
import useDismissiblePersistent from '../../../../../../hooks/useDismissiblePersistent';
import { PPI_WARNING_PRINT_PRODUCT_CONFIG } from '../../../../../../constants/dismissibleKeys';
import DesignEditorPreviewPane from '../../../../../../components/global/DesignEditor/components/DesignEditorPreviewPane';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  accountCard: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  onElementConfigurationChange: PropTypes.func.isRequired,
  cardElementLoading: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    is_album: PropTypes.bool,
  }),
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  defaultPhoto: PropTypes.shape({
    id: PropTypes.string,
  }),
};

const PrintProductConfiguratorPreviewPane = ({
  className,
  loading,
  accountCard,
  onElementConfigurationChange,
  cardElementLoading,
  albumMembershipGroup,
  identity,
  defaultPhoto,
}) => {
  const classes = classNames({
    'is-loading': loading,
    [className]: !!className,
  });
  const openModal = useOpenModal();
  const { visible, onDismiss } = useDismissiblePersistent(
    PPI_WARNING_PRINT_PRODUCT_CONFIG,
  );

  if (loading && !accountCard) {
    return (
      <div className={classes}>
        <NativeActivityIndicator />
      </div>
    );
  }

  return (
    <DesignEditorPreviewPane className={classes}>
      {accountCard && (
        <Fragment>
          <AccountCard
            className="print-product-configurator-account-card"
            onElementConfigurationChange={onElementConfigurationChange}
            accountCard={accountCard}
            cardElementLoading={cardElementLoading}
            onPhotoPpiWarning={() => {
              if (visible) {
                openModal(CARD_ELEMENT_PHOTO_PPI_WARNING_MODAL);
              }
            }}
            photosContext={{
              identity_id: identity?.id,
              album_id:
                albumMembershipGroup &&
                (albumMembershipGroup.is_album
                  ? albumMembershipGroup.id
                  : undefined),
              album_folder_id:
                albumMembershipGroup &&
                (!albumMembershipGroup.is_album
                  ? albumMembershipGroup.id
                  : undefined),
              root_album_folder_id:
                albumMembershipGroup && albumMembershipGroup.is_album
                  ? albumMembershipGroup.album.root_album_folder?.id
                  : undefined,
              is_album_membership_group: !!albumMembershipGroup,
            }}
            allowPhotoChange={false}
            defaultPhoto={defaultPhoto}
          />
          <p className="text-sm text-italic mt-2 mb-0">
            Press on the photo to tweak crop and placement.
          </p>
        </Fragment>
      )}

      <CardElementPhotoPpiWarningModal onPersistentDismiss={onDismiss} />
    </DesignEditorPreviewPane>
  );
};

PrintProductConfiguratorPreviewPane.propTypes = propTypes;

export default PrintProductConfiguratorPreviewPane;
